import FooterSwitches from './FooterSwitches';

export default FooterSwitches;
